import {Component, Vue} from "vue-property-decorator";


@Component
export default class ScrollToLoad extends Vue {
  public allDataList: object[] = []
  public displayedDataList: object[] = []
  public isDataLoading = false
  //how many items will be load on 1 scroll
  public itemCountPerLoading = 5
  public itemPageIndex = 0
  public loadedItemSectionHeight = 465
  public pageCount = 1
  public query = {
    pageIndex: 1,
    pageSize: 5,
  }

  get itemPageCount() {
    return this.allDataList.length? Math.ceil(this.allDataList.length/this.itemCountPerLoading) : 1
  }

  mounted() {
    window.addEventListener("scroll", this.scrollToLoad); //watch scroll
  }

  destroyed() {
    window.removeEventListener("scroll", this.scrollToLoad); //remove wathc scroll
  }

  get inPageCount(){
    return this.pageCount >= this.query.pageIndex
  }

  get isLoadAllData(){
    return this.itemPageCount > this.itemPageIndex
  }

  // beforeMount() {
  //   // 在页面挂载前就发起请求
  //   this.addNewDataList();
  // }

  scrollToLoad(){
    // 变量 scrollTop 是滚动条滚动时, 距离顶部的距离
    const scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    // 变量 windowHeight 是可视区的高度
    const windowHeight =
      document.documentElement.clientHeight || document.body.clientHeight;
    // 变量 scrollHeight 是滚动条的总高度
    const scrollHeight =
      document.documentElement.scrollHeight || document.body.scrollHeight;
    // 滚动条到底部的条件 (距底部 465px 时触发加载)
    if (!this.isDataLoading && (scrollTop + windowHeight >= scrollHeight - this.loadedItemSectionHeight)  && this.inPageCount && this.isLoadAllData) {
      this.isDataLoading = true;
      // 延时触发数据加载
      setTimeout(async() => {
        // 后端需要进行分页, 然后前端从后端拿来实现滚动加载
        // 这里利用数组 push 来模拟从后端拿到的数据
        await this.addNewDataList()
        this.isDataLoading = false;
      }, 500);
    }
  }
  addNewDataList() {
    console.log('use child method')
  }

}
